import React, { useState, useEffect } from 'react';
import { Container, Tabs, Tab, Box } from '@mui/material';
import { UserWallets } from './Billing';
import { BillingPreferences } from "./BillingPreferences";
import { useNavigate, useLocation } from 'react-router-dom';
import {isMobile, parkedDomain} from "../App/utils";
import { PaymentHistory } from "./PaymentHistory";

export const BillingPage = ({userProfile}) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get initial tab from URL or default to 0
    const getInitialTab = () => {
        const params = new URLSearchParams(location.search);
        const tab = params.get('tab');
        return tab ? parseInt(tab) : 0;
    };

    const [activeTab, setActiveTab] = useState(getInitialTab);

    // Update URL when tab changes
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('tab', activeTab.toString());
        navigate({
            pathname: location.pathname,
            search: searchParams.toString()
        }, { replace: true });
    }, [activeTab, navigate, location.pathname]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Container maxWidth={false}>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label="billing tabs"
                centered={true}
            >
                <Tab label="Dashboard" sx={{ textTransform: 'none' }} />
                {!parkedDomain && <Tab label={isMobile ? "Payments" : "Payment History"} sx={{ textTransform: 'none' }} />}
            </Tabs>
            <Box sx={{ mt: 3 }}>
                {activeTab === 0 && <UserWallets userProfile={userProfile} />}
                {activeTab === 1 && <PaymentHistory userProfile={userProfile} />}
            </Box>
        </Container>
    );
};

export default BillingPage;